import { useEffect, useRef, useState } from "react";
import { useQuery } from "hooks/useQuery";
import {
  Box,
  CircularProgress,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  AthleticLogo,
  BTLogo,
  IconGmail,
  IconWhatsapp,
} from "assets/icons/config";
import {
  getProductRecommended,
  getProposal,
  postProposalsLogs,
} from "services/payments";
import { useAuthToken } from "hooks/useAuthToken";
import PageNotFound from "components/PageNotFound";
import FooterProposal from "./components/FooterProposal";
import ListProductProposal from "./components/ListProductProposal";
import ProposalMobil from "./components/ProposalMobil";
import ListProductRecommended from "./components/ListProductRecommended";

const Proposal = ({ props }) => {
  const { isMobile } = props;
  const refs = useRef([]);
  const query = useQuery();
  const uuid = query.get("uuid");
  const currentBrand = query.get("b");
  const [data, setData] = useState(null);
  const { getAuthToken } = useAuthToken();
  const [loading, setLoading] = useState(true);
  const [maxHeight, setMaxHeight] = useState(0);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [productRecommended, setProductRecommended] = useState(false);
  const [text, setText] = useState(
    "En estos momentos, la funcionalidad está deshabilitada."
  );
  const brand = {
    name: currentBrand == 1 ? "Bodytech" : "Athetic",
    background: currentBrand == 1 ? "#FDF0EA" : "#fccfdd",
    color: currentBrand == 1 ? "#E7662B" : "#e50151",
  };

  useEffect(() => {
    const heights = refs.current.map((ref) => ref?.offsetHeight || 0);
    const max = Math.max(...heights);
    setMaxHeight(max);
  }, [data]);

  useEffect(() => {
    handlePostProposalLogs();
    setLoading(true);
    localStorage.setItem("current_brand", currentBrand);

    (async () => {
      await getAuthToken();
      await getProposal(uuid)
        .then(({ data }) => {
          if (data.status == "success") {
            setData(data.data);
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
      await getProductRecommended()
        .then(({ data }) => {
          if (data.status == "success") {
            setProductRecommended(data.data);
          }
        })
        .catch(({ error }) => {
          console.log(error);
        });
    })();
  }, []);

  const handlePostProposalLogs = (actionType = null) => {
    const data = {
      proposal_uuid: uuid,
      brand_id: currentBrand,
      action_type: actionType,
      device_type: isMobile ? "mobile" : "desktop",
    };
    postProposalsLogs(data)
      .then(({ data }) => {})
      .catch(({ err }) => {
        console.log(err);
      });
  };

  console.log(data);

  const handleClickGmail = () => {
    handlePostProposalLogs("touch email");
    const email = data.email_user;
    const subject = `Cotización Bodytech N°${data.proposal_id} - ${data.user_proposal.name}`;
    const body =
      "Buen día, el/los planes en los que estoy interesado(a) para que me envíen el link de pago, son: ";
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(gmailUrl, "_blank");
  };

  const handleClickWhatsapp = () => {
    handlePostProposalLogs("touch whatsapp");
    setOpenTooltip(true);
    setTimeout(() => {
      setOpenTooltip(false);
    }, 2000);
  };

  if (loading) {
    return (
      <Box
        maxWidth="100%"
        height="98vh"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const isProductDuo =
    data?.info_products?.sports_products.length > 0 &&
    data?.info_products?.others_products.length > 0;

  return data != null ? (
    <Box maxWidth="100%" height="98vh">
      {!isMobile ? (
        <>
          <Grid
            container
            spacing={0.8}
            py={{ xs: 2, md: 6 }}
            px={{ xs: 3, md: 12 }}
          >
            <Grid
              xs={2}
              container
              justifyContent={{ xs: "center", md: "flex-start" }}
            >
              {["1", "3"].includes(currentBrand) ? (
                <BTLogo width={115} height={70} />
              ) : (
                <AthleticLogo />
              )}
            </Grid>

            <Grid
              paddingRight={"12px"}
              xs={4}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={{ md: "space-between" }}
              alignItems={{ xs: "center", md: "flex-start" }}
              overflow={"scroll"}
              sx={{
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "-ms-overflow-style": "none",
                "scrollbar-width": "none",
              }}
            >
              <Typography
                variant="h5"
                fontSize={"12px"}
                display={"flex"}
                alignItems={"center"}
                marginRight={"10px"}
              >
                Asesor
              </Typography>
              <hr style={{ margin: "4px 0", width: "80%" }}></hr>
              <Box display={"flex"}>
                <Typography
                  width={"50px"}
                  fontSize={"10px"}
                  color={"#a4a4a4"}
                  display={"flex"}
                  alignItems={"center"}
                  marginRight={"10px"}
                >
                  Nombre
                </Typography>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#3C3C3B",
                    margin: "0px",
                    fontWeight: "500",
                  }}
                >
                  {data.name_user}
                </p>
              </Box>
              <Box display={"flex"}>
                <Typography
                  width={"50px"}
                  fontSize={"10px"}
                  color={"#a4a4a4"}
                  display={"flex"}
                  alignItems={"center"}
                  marginRight={"10px"}
                >
                  Email
                </Typography>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#3C3C3B",
                    margin: "0px 10px 0px 0px",
                    fontWeight: "500",
                  }}
                >
                  {data.email_user}
                </p>
                <Box display={"flex"}>
                  <Box
                    onClick={handleClickGmail}
                    display={"flex"}
                    alignItems={"center"}
                  >
                    <IconGmail size={"16px"} />
                  </Box>
                </Box>
              </Box>
              <Box display={"flex"}>
                <Typography
                  width={"50px"}
                  fontSize={"10px"}
                  color={"#a4a4a4"}
                  display={"flex"}
                  alignItems={"center"}
                  marginRight={"10px"}
                >
                  Sede
                </Typography>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#3C3C3B",
                    margin: "0px",
                    fontWeight: "500",
                  }}
                >
                  {data.venue_name}
                </p>
              </Box>
              <Box display={"flex"}>
                <Typography
                  width={"50px"}
                  fontSize={"10px"}
                  color={"#a4a4a4"}
                  display={"flex"}
                  alignItems={"center"}
                  marginRight={"10px"}
                >
                  Contacto
                </Typography>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#3C3C3B",
                    margin: "0px 10px 0px 0px",
                    fontWeight: "500",
                  }}
                >
                  {data.phone_user}
                </p>
                <Tooltip title={text} arrow placement="top" open={openTooltip}>
                  <Box
                    marginRight={"20px"}
                    onClick={handleClickWhatsapp}
                    display={"flex"}
                    alignContent={"center"}
                  >
                    <IconWhatsapp size={16} />
                  </Box>
                </Tooltip>
              </Box>
            </Grid>
            <Grid
              paddingLeft={"12px"}
              xs={4}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={{ md: "flex-start" }}
              alignItems={{ xs: "center", md: "flex-start" }}
              overflow={"scroll"}
              sx={{
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "-ms-overflow-style": "none",
                "scrollbar-width": "none",
              }}
            >
              <Typography
                variant="h5"
                fontSize={"12px"}
                display={"flex"}
                alignItems={"center"}
                marginRight={"10px"}
              >
                Afiliado
              </Typography>
              <hr style={{ margin: "4px 0", width: "80%" }}></hr>
              <Box display={"flex"}>
                <Typography
                  width={"50px"}
                  fontSize={"10px"}
                  color={"#a4a4a4"}
                  display={"flex"}
                  alignItems={"center"}
                  marginRight={"10px"}
                >
                  Nombre
                </Typography>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#3C3C3B",
                    margin: "0px",
                    fontWeight: "500",
                  }}
                >
                  {data.user_proposal.name}
                </p>
              </Box>
            </Grid>
            <Grid
              xs={2}
              display={"flex"}
              flexDirection={"column"}
              alignItems={{ xs: "center", md: "flex-end" }}
              justifyContent={{ md: "center" }}
            >
              <Box width={"max-content"} display={"flex"}>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#3C3C3B",
                    margin: "0px",
                    fontWeight: "800",
                  }}
                >
                  Cotización
                </p>
                <Typography marginLeft={"10px"}>
                  N° {data.proposal_id}
                </Typography>
              </Box>
              <Box width={"max-content"} display={"flex"}>
                <Typography
                  fontSize={"12px"}
                  color={"#a4a4a4"}
                  display={"flex"}
                  alignItems={"center"}
                >
                  {data.date}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid
            container
            px={{ xs: 2, md: 8 }}
            overflow={"scroll"}
            sx={{
              "&::-webkit-scrollbar": {
                display: "none",
              },
              "-ms-overflow-style": "none",
              "scrollbar-width": "none",
            }}
          >
            {data?.info_products?.sports_products.length > 0 && (
              <Grid item xs={6}>
                <Typography
                  style={{
                    backgroundColor: brand.background,
                    color: brand.color,
                  }}
                  width={"max-content"}
                  variant="h5"
                  fontSize={"12px"}
                  margin={"auto"}
                  padding={"4px 12px"}
                  borderRadius={"12px"}
                >
                  Servicios Médicos Deportivos
                </Typography>
                <ListProductProposal
                  data={data?.info_products?.sports_products}
                  brand={brand}
                  refs={refs}
                  maxHeight={maxHeight}
                />
              </Grid>
            )}
            {isProductDuo && (
              <Grid
                item
                xs={1}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Box
                  style={{
                    marginLeft: "18px",
                    border: "solid 0.5px rgb(120, 119, 119)",
                    width: "0",
                    height: "100%",
                  }}
                ></Box>
              </Grid>
            )}
            {data?.info_products?.others_products.length > 0 && (
              <Grid item xs={5}>
                <Typography
                  style={{
                    backgroundColor: brand.background,
                    color: brand.color,
                  }}
                  width={"max-content"}
                  margin={"auto"}
                  padding={"4px 12px"}
                  borderRadius={"12px"}
                  variant="h5"
                  fontSize={"12px"}
                >
                  Servicios Médicos Complementarios
                </Typography>
                <ListProductProposal
                  isTitle={!isProductDuo}
                  data={data?.info_products?.others_products}
                  brand={brand}
                  refs={refs}
                  maxHeight={maxHeight}
                />
              </Grid>
            )}
          </Grid>
          {productRecommended.length > 0 && (
            <>
              <Grid
                container
                spacing={2}
                py={{ xs: 1, md: 2 }}
                px={{ xs: 3, md: 16 }}
              >
                <Typography variant="h5" fontSize={"18px"}>
                  Productos que te podrian interesar
                </Typography>
              </Grid>
              <Grid
                container
                spacing={2}
                py={{ xs: 1, md: 2 }}
                px={{ xs: 3, md: 12 }}
              >
                <ListProductRecommended
                  brand={brand}
                  productRecommended={productRecommended}
                />
              </Grid>
            </>
          )}
          <Typography
            variant="h5"
            width={"100%"}
            textAlign={"center"}
            fontSize={"14px"}
          >
            *No se mantienen tarifas después de la vigencia de la oferta
          </Typography>
          {currentBrand == 1 && <FooterProposal brand={brand} />}
        </>
      ) : (
        <ProposalMobil
          currentBrand={currentBrand}
          data={data}
          brand={brand}
          uuid={uuid}
          productRecommended={productRecommended}
        />
      )}
    </Box>
  ) : (
    <PageNotFound></PageNotFound>
  );
};

export default Proposal;
